
import { defineComponent, ref, reactive, onMounted, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
    setup(){ 
        const title = ref('Users')
        const store = useStore()
        const router = useRouter()

        const fields = ref<any>([
             {
                title: 'Group',
                dataIndex: 'business_unit.name',
            },
            {
                title: 'Email',
                dataIndex: 'email',
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
            },
            {
                title: 'Middle Name',
                dataIndex: 'middle_name',
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
            },
            {
                title: 'Role',
                dataIndex: 'role.name',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                slots: {customRender: 'action'},
                align: 'center'
            }
        ]);

        const index = (payload = {page: 1}) => {
            store.dispatch('BusinessUnitAdmin/index', payload)
        }

        const filterRecord = (payload: any) => {
            index(payload)
        }

        const createRecord = () => {
            router.push('create/business-unit-admin')
        }

        const editRecord = (record: any) => {
            router.push('edit/business-unit-admin/' + record.id)
        }

        const deleteRecord = (record: any) => {
            store.dispatch('User/destroy', record.id).then(() => {
                index();
            });
        }

        onMounted(index)

        const items = computed(() => store.getters['BusinessUnitAdmin/items'])
        const loading = computed(() => store.getters['BusinessUnitAdmin/status'])

        return {
            title,
            fields,
            items,
            loading,
            filterRecord,
            createRecord,
            editRecord,
            deleteRecord,
        }
    }
});

